const isCustomOption = ({ label }) => label.indexOf('Custom:') > -1;
// Get min value of each range in price category for sorting order
const sortOrder = (chip) => parseInt(chip.id.replace(/$|\|.*/, ''), 10);

const onChipClick = (facet, { removeCheckboxValuesByValue }) => {
  const { category: facetName, id: selectedChip, contents } = facet.selected;
  /* istanbul ignore else */
  if (isCustomOption({ label: contents.text })) {
    removeCheckboxValuesByValue(facetName, selectedChip);
  }
};

const onApplyFilter = ({ values, name }, { addCheckboxValues, removeCustomCheckboxValues }) => {
  removeCustomCheckboxValues(name, isCustomOption);
  const customOption = values.find(isCustomOption);
  /* istanbul ignore else */
  if (customOption) {
    const { label, value } = customOption;
    addCheckboxValues(name, { label, value });
  }
};

export default {
  isCustomOption,
  sortOrder,
  onChipClick,
  onApplyFilter,
};
